function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-accordion\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.08,10.71H13.77a1.13,1.13,0,1,1,0-2.25H37.08a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.08,21.33H13.77a1.13,1.13,0,1,1,0-2.25H37.08a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.08,31.94H13.77a1.13,1.13,0,1,1,0-2.25H37.08a1.13,1.13,0,1,1,0,2.25Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.32,10,2.1,12.45a.62.62,0,0,1-1-.44V7.17A.62.62,0,0,1,2.1,6.73L6.32,9.15A.63.63,0,0,1,6.32,10Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.32,20.64,2.1,23.06a.62.62,0,0,1-1-.44V17.78a.61.61,0,0,1,1.05-.43l4.22,2.41A.63.63,0,0,1,6.32,20.64Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.32,31.25,2.1,33.67a.62.62,0,0,1-1-.44V28.4A.61.61,0,0,1,2.1,28l4.22,2.42A.62.62,0,0,1,6.32,31.25Z",
  fill: "#231f20"
});

function SvgCmsAccordion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgCmsAccordion;